import React, { useState, useEffect } from 'react'
import ConnectMoreAccounts from '../../../../../../components/bankAccount/modals/connectMoreAccounts'
import ExportConnectionsBroadModal from './ExportConnectionsBroadModal'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import PermissionGate from '../../../../../../helpers/PermissionGate'

function ExternalConnectionsTableDropdown(props) {
  const [showConnectMoreAccountsModal, setShowConnectMoreAccountsModal] = useState(false)
  const [exportModalVisible, setExportModalVisible] = useState(false)

  return (
    <Stack direction='column' width={'100%'} spacing={1}>
      <PermissionGate
        requiredRole='dashboardEditor'
        readOnly={
              <Button variant='contained' disabled fullWidth sx={{ fontSize: 14, textTransform: 'none' }}>
                + Add Bank Connections
              </Button>
        }
        toolTipText='Only admins and dashboard editors may add bank connections'
      >
        <Button
          onClick={() => setShowConnectMoreAccountsModal(true)}
          variant='contained'
          color='primary'
          sx={{ fontSize: 14, textTransform: 'none' }}
        >
          + Add Bank Connections
        </Button>
      </PermissionGate>
      <Button
        sx={{ fontSize: 14, textTransform: 'none' }}
        onClick={() => {
          if (props.tableData.length < 1) {
            return
          }
          setExportModalVisible(true)
        }}
        disabled={!props.tableData || props.tableData.length === 0}
        variant='outlined'
      >
        Export Data
      </Button>

      {exportModalVisible && (
        <ExportConnectionsBroadModal
          tableData={props.tableData}
          exportModalVisible={exportModalVisible}
          handleCancelModal={() => setExportModalVisible(false)}
        />
      )}
      {showConnectMoreAccountsModal && (
        <ConnectMoreAccounts
          visible={showConnectMoreAccountsModal}
          handleCancelModal={() => setShowConnectMoreAccountsModal(false)}
          plaidAccessTokenOnSuccess={props.plaidAccessTokenOnSuccess}
        />
      )}
    </Stack>
  )
}

export default ExternalConnectionsTableDropdown
